export default "__VITE_PUBLIC_ASSET__cf28a38d__"